export default "__VITE_ASSET__CdStyIoF__"